import { cn } from '@/lib/utils'

interface MetricDataPoint {
  label: string
  value: number
}

interface MetricsChartProps {
  data: MetricDataPoint[]
  title?: string
  valueFormatter?: (v: number) => string
  className?: string
}

export function MetricsChart({ data, title, valueFormatter, className }: MetricsChartProps) {
  if (data.length === 0) {
    return (
      <div className={cn('p-4 bg-white rounded-lg border border-slate-200', className)}>
        <p className="text-sm text-slate-400 text-center py-8">Nessun dato disponibile</p>
      </div>
    )
  }

  const max = Math.max(...data.map((d) => d.value))
  const fmt = valueFormatter ?? ((v: number) => String(v))

  return (
    <div className={cn('bg-white rounded-lg border border-slate-200 p-4', className)}>
      {title && <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-4">{title}</p>}
      <div className="space-y-2">
        {data.map((point) => {
          const pct = max > 0 ? (point.value / max) * 100 : 0
          return (
            <div key={point.label} className="flex items-center gap-3">
              <span className="text-xs text-slate-500 w-14 text-right flex-shrink-0 font-medium">
                {point.label}
              </span>
              <div className="flex-1 bg-slate-100 rounded-full h-5 relative overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-primary-500 rounded-full transition-all duration-500"
                  style={{ width: `${pct}%` }}
                />
                <span className="absolute inset-y-0 right-2 flex items-center text-[10px] font-semibold text-slate-700">
                  {fmt(point.value)}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
